<div class="not-registered-background d-flex flex-column justify-content-between align-items-center">
  <div class="page-header">
    <img src="../../../../assets/images/header-logo.png" alt="UDTHub header logo" width="150px" />
  </div>
  <div class="message-container d-flex flex-column align-items-center justify-content-center">
    <div class="card d-flex flex-column align-items-center text-center">
      <mat-icon class="error-icon mb-3">person_off</mat-icon>
      <h2 class="mt-0 mb-2">We couldn't find an account with this email.</h2>
      <p class="description m-0 mb-4">Please contact your administrator to get started.</p>
      <button mat-flat-button color="primary" class="large-button" (click)="backToLogin()">Back to Login</button>
    </div>
  </div>
  <div class="page-footer d-flex justify-content-between align-items-center">
    <img
      src="../../../../assets/svg/udt-hub-logo.svg"
      class="img-fluid"
      style="max-width: 80px"
      alt="UDTHub footer logo"
    />
  </div>
</div>
